import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import classNames from 'classnames';

import type { TabProps } from '../../Tabs/Tab';

import './NotifcationsCenterTab.scss';
import Tabs from '../../Tabs';

export interface NotificationsCenterTabProps extends Omit<
  TabProps,
  'label' | 'onClick'
> {
  onClick?: () => void;
  badge?: number;
  label: string;
}

// Tab MORA biti direktno dete MUI TabList-a (bez wrapper elementa): TabList
// klonira decu i injektuje selected/indicator/a11y propove — wrapper bi ih
// progutao pa aktivan tab ne bi imao indikator ni aria-selected
export const NotificationsCenterTab = ({
  badge,
  className,
  label,
  onClick,
  value,
  ...muiInjected
}: NotificationsCenterTabProps) => {
  return (
    <Tabs.Tab
      {...muiInjected}
      label={
        <Badge
          className="Mfw-NotificationsCenterTab-badge"
          badgeContent={badge}
          color="primary"
        >
          <Typography>{label}</Typography>
        </Badge>
      }
      className={classNames('Mfw-NotificationsCenterTab-root', className)}
      onClick={onClick}
      value={value}
    />
  );
};
